import { calculateNormalizedPercentage } from './calculate-normalized-percentage';

/**
 * Calculates the position and alignment for a tick mark on the thermobar.
 *
 * @param value - The value of the tick mark.
 * @param min - The minimum value of the range.
 * @param max - The maximum value of the range.
 * @returns An object containing the left position percentage and text alignment.
 */
export const calculateTickPosition = (
  value: number,
  min: number,
  max: number,
) => {
  const tickPercentage = calculateNormalizedPercentage(value, min, max);

  let alignment: 'left' | 'center' | 'right' = 'center';
  if (tickPercentage === 0) alignment = 'left';
  if (tickPercentage === 100) alignment = 'right';

  return {
    left: `${tickPercentage}%`,
    alignment,
  };
};
